import { startLocalMode } from './modes/local';
import type { ModeHandle } from './modes/mode';
import { startOnlineMode } from './modes/online';
import { browserTokenStore, connectWebSocket, resolveWsUrl, withLag } from './net';

// Entry point. The default is the online mode against the server (VITE_WS_URL, see net.ts);
// `?mode=local` plays against the bot in this tab, `?seed=<n>` makes such a match reproducible.
// Dev only: `?lag=<ms>` delays every message both ways to watch prediction and correction at work.
const params = new URLSearchParams(window.location.search);

const canvas = document.getElementById('game') as HTMLCanvasElement | null;
const hud = document.getElementById('hud');
if (!canvas || !hud) throw new Error('index.html must provide #game and #hud');

let game: ModeHandle;
if (params.get('mode') === 'local') {
  const seedParam = Number(params.get('seed'));
  const seed = Number.isInteger(seedParam) && seedParam > 0 ? seedParam : (Date.now() % 1_000_000) + 1;
  game = startLocalMode({ canvas, hud, seed });
} else {
  const lag = Number(params.get('lag'));
  const connect = import.meta.env.DEV && Number.isFinite(lag) && lag > 0 ? withLag(connectWebSocket, lag) : connectWebSocket;
  game = startOnlineMode({ canvas, hud, url: resolveWsUrl(import.meta.env, window.location), connect, tokens: browserTokenStore() });
}

// Dev only: lets browser checks and the console inspect the running match (`__game.state()`, `__game.net?.()`).
if (import.meta.env.DEV) (window as unknown as { __game: ModeHandle }).__game = game;
